<template>
  <el-dialog :title="getTitle"
             :visible.sync="showModal"
             @close="handleCancel"
             width="40%">
    <el-col :span="24">
      <el-form :model="manInfo"
               :rules="manRules"
               ref="manForm"
               label-width="70px"
               class="man-form">
        <el-form-item label="类别："
                      prop="dorm_log_type">
          <el-select v-model="manInfo.dorm_log_type"
                     placeholder="请选择类别">
            <el-option v-for="(item, index) in typeList"
                       :key="index"
                       :label="item.name"
                       :value="item.code"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="时间："
                      prop="timestamp">
          <el-date-picker v-model="manInfo.timestamp"
                          type="date"
                          value-format="yyyy-MM-dd"
                          :picker-options="dateOption"
                          placeholder="选择日期">
          </el-date-picker>
        </el-form-item>
        <el-form-item label="房间："
                      prop="room_name">
          <el-input v-model.trim="manInfo.room_name"
                    placeholder="请输入房间"></el-input>
        </el-form-item>
        <el-form-item label="姓名："
                      prop="person_name">
          <el-input v-model.trim="manInfo.person_name"
                    placeholder="请输入姓名"></el-input>
        </el-form-item>
        <el-form-item label="备注："
                      prop="remarks">
          <el-input type="textarea"
                    v-model.trim="manInfo.remarks"
                    placeholder="请输入备注"></el-input>
        </el-form-item>
      </el-form>
    </el-col>
    <span slot="footer"
          class="dialog-footer">
      <el-button @click="handleCancel">取 消</el-button>
      <el-button v-has="'/dorm_log/add' || '/dorm_log/edit'"
                 type="primary"
                 @click="handleConfirm('manForm')">
        确 定
      </el-button>
    </span>
  </el-dialog>
</template>

<script>
import fetch from '@/common/api'
export default {
  props: {
    isShow: {
      type: Boolean
    },
    data: {
      type: Object
    }
  },
  data() {
    return {
      from: this.data.type,
      showModal: this.isShow,
      manInfo: {
        dorm_log_type: '',
        room_name: '',
        person_name: '',
        timestamp: '',
        remarks: ''
      },
      manRules: {
        dorm_log_type: [{ required: true, message: '请选择人员类别' }],
        room_name: [{ required: true, message: '请选择房间' }],
        person_name: [{ required: true, message: '请输入人员名称' }],
        timestamp: [{ required: true, message: '请选择有效期' }]
      },
      dateOption: {
        disabledDate(time) {
          return time.getTime() > Date.now()
        }
      },
      typeList: [],
      roomList: []
    }
  },
  computed: {
    getTitle() {
      return this.data.type === 'add' ? '添加宿管日志' : '编辑宿管日志'
    }
  },
  created() {
    this.getItemList()
    if (this.data.type === 'edit') {
      this.getInfo()
    }
  },
  methods: {
    // 获取编辑信息
    getInfo() {
      fetch.getDormLogInfo({ id: this.data.id }).then((data) => {
        data.procData(
          data.res,
          (data) => {
            this.manInfo = data
          },
          (err) => {
            this.$message.error(err)
          }
        )
      })
    },
    // 获取介质类型
    getItemList() {
      fetch.getItemList({ type_code: 'dorm_log_type' }).then((data) => {
        data.procData(
          data.res,
          (data) => {
            this.typeList = data.list
          },
          (err) => {
            this.$message.error(err)
          }
        )
      })
    },
    handleConfirm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          if (this.from === 'add') {
            fetch.addDormLog({ ...this.manInfo }).then((data) => {
              data.procData(
                data.res,
                () => {
                  this.$message.success('操作成功')
                  this.handleCancel('refresh')
                },
                (err) => {
                  this.$message.error(err)
                }
              )
            })
          } else {
            fetch.editDormLog({ ...this.manInfo }).then((data) => {
              data.procData(
                data.res,
                () => {
                  this.$message.success('操作成功')
                  this.handleCancel('refresh')
                },
                (err) => {
                  this.$message.error(err)
                }
              )
            })
          }
        } else {
          return false
        }
      })
    },
    handleCancel(type) {
      this.$emit('handleClose', type)
    }
  }
}
</script>

<style></style>
